import { useAuth } from "@/contexts/AuthContext";
import { useNotify } from "@/contexts/NotifyContext";
import axios from "axios";
import { Roles } from "iasma-datatypes";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom"
import { Button } from "../ui/button";
import { Switcher } from "../Switcher";
import { ChartBar, CheckSquare, Cog, GraduationCap, Mail, QrCode, University } from "lucide-react";
import { AlumniSearch, SearchOption } from "./AlumniSearch";

export function ViewRolesEdit() {
	const navigate = useNavigate();

	const { userId: paramId, email: paramEmail, grad: paramGrad } = useParams()
	const { getRoles, hasRole, saveRoles, setToken } = useAuth();
	const { setNotify } = useNotify();

	const [email, setEmail] = useState<string | undefined>(paramEmail)             // --> change email to userEmail
	const [userId, setUserId] = useState<number>(paramId ? Number(paramId) : 0)            // --> change emailId to userId

	const [roles, setRoles] = useState<string[] | undefined>(undefined);
	const [originalRoles, setOriginalRoles] = useState<string[] | undefined>(undefined);
	const [hasChanged, setHasChanged] = useState(false);

	const [userName, setUserName] = useState<string | undefined>(undefined)

	const [selectedSearch, setSelectedSearch] = useState<SearchOption | null>(null);

	useEffect(() => {
		console.log("fetchUserRoles", userId)
		async function fetchUserRoles() {
			setNotify(null)
			setToken(axios);
			try {
				// setUserName(undefined)
				// setRoles(undefined);
				let response = await getRoles(userId)
				const { roles } = response.data;
				console.log("roles", roles)
				if (roles.length > 0) {
					setUserName(roles[0].Name)
					setRoles(roles[0].Roles);
					setOriginalRoles(structuredClone(roles[0].Roles));
				} else {
					setRoles([])
					setOriginalRoles([])
				}
			} catch (error) {
				setNotify({ title: "User Roles Failed", error, severity: 'error' });
			}
		}
		if (userId > 0)
			fetchUserRoles()
	}, [userId]);

	useEffect(() => {
		let changed = true;
		if (roles && originalRoles) {
			changed = (roles.length !== originalRoles.length) ||
				!roles.every((value, index) => value === originalRoles[index])
		} else if (roles) {
			changed = true
		} else if (originalRoles) {
			changed = true
		} else {
			changed = false
		}
		setHasChanged(changed)
	}, [roles]);

	const onRolesSave = async () => {
		if (email) {
			setNotify(null)
			setToken(axios);
			try {
				let data = {
					Email: email,
					UserId: userId,
					Roles: roles,
				};
				await saveRoles(data);
				navigate(-1)
			} catch (error) {
				setNotify({ title: "Save Roles Failed", error, severity: 'error' });
			}
		}
	}

	const onRolesClose = async () => {
		navigate(-1)
	}

	const onRoleSwitch = (role: string, checked: boolean) => {
		setRoles((prevRoles) => {
			const newRoles = Array.isArray(prevRoles) ? [...prevRoles] : [];
			const idx = newRoles.indexOf(role);

			if (checked && idx < 0) {
				newRoles.push(role);
			} else if (!checked && idx >= 0) {
				newRoles.splice(idx, 1);
			}

			return newRoles;
		});
	}

	const insertRoleItem = (title: string, role: string, faIcon: any) => {
		let checked = roles ? roles?.indexOf(role) >= 0 : false;
		return (
			<div className="flex flex-row justify-between">
				<div className="flex flex-row gap-2">{faIcon} {title}</div>
				<div><Switcher checked={checked} onCheckChange={onRoleSwitch} id={role}></Switcher></div>
			</div>
		);
	};

	const onSelected = (option: SearchOption | null) => {
		console.log("onSelected", option)
		if (option) {
			setUserId(option.UserId ?? 0);
			setEmail(option.Email);
		}
	}

	return <div>

		{!paramId &&
			<div className="max-w-sm px-2">
				<label htmlFor="country-search" className="block text-sm font-medium text-slate-700 mb-1.5">
					Cari Alumni
				</label>
				<AlumniSearch onSelected={onSelected} userOnly={true}/>
			</div>
		}

		<div className="m-3">
			<h2 className="text-xl mb-1" style={{ fontFamily: "'Source Serif 4', serif", fontWeight: 600 }}>
				{userName}
			</h2>
			<div className="flex items-center gap-1.5 text-sm" style={{}}>
				<Mail size={13} />
				{paramEmail}
			</div>
			<div className="flex items-center gap-1.5 text-sm font-semibold" style={{}}>
				<GraduationCap size={13} />
				{paramGrad}
			</div>
		</div>
		<form>
			{roles && (<div className="max-w-150 flex flex-col gap-3">
				{insertRoleItem("Admin IASMA", "admin.all", <University />)}
				{insertRoleItem("Admin Angkatan", "admin.angkatan", <GraduationCap />)}
				{insertRoleItem("Panitia Absensi Pindai", "panitia.pindai", <QrCode />)}
				{insertRoleItem("Panitia Absensi Manual", "panitia.absensi", <CheckSquare />)}
				{hasRole(Roles.SUPER_SUPER) && insertRoleItem("view.chart", "view.chart", <ChartBar />)}
				{hasRole(Roles.SUPER_SUPER) && insertRoleItem("super.super", "super.super", <Cog />)}

				<Button type="button" variant={"destructive"} disabled={!hasChanged} onClick={onRolesSave}>Simpan</Button>
				<Button type="button" variant={"secondary"} onClick={onRolesClose}>Tutup</Button>
			</div>)}
		</form>
	</div>
}